import { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  contactFormSchema,
  defaultMessages,
  sendContactMessage,
} from "./contactFormHelpers";

const ContactForm = ({ variant = "page", title = null }) => {
  const [responseMessage, setResponseMessage] = useState(null);
  const [responseType, setResponseType] = useState(null);

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
  } = useForm({
    resolver: yupResolver(contactFormSchema),
  });

  const onSubmit = async (data) => {
    try {
      const message = await sendContactMessage(data);
      setResponseMessage(message);
      setResponseType("success");
      reset();
    } catch (error) {
      setResponseMessage(error?.message || defaultMessages.error);
      setResponseType("error");
    }
  };

  if (variant === "landing") {
    return (
      <div className="bl-connect-form-card">
        {title ? (
          <div className="bl-connect-form-card__title">{title}</div>
        ) : null}
        <form
          className="bl-connect-form"
          onSubmit={handleSubmit(onSubmit)}
          noValidate
        >
          <label>
            Name *
            <input type="text" placeholder="Your name" {...register("name")} />
            {errors.name ? (
              <span className="bl-connect-form__error">
                {errors.name.message}
              </span>
            ) : null}
          </label>
          <label>
            Email *
            <input
              type="email"
              placeholder="your@email.com"
              {...register("email")}
            />
            {errors.email ? (
              <span className="bl-connect-form__error">
                {errors.email.message}
              </span>
            ) : null}
          </label>
          <label>
            Phone
            <input
              type="tel"
              placeholder="Phone"
              className="no-arrows"
              {...register("phone")}
            />
            {errors.phone ? (
              <span className="bl-connect-form__error">
                {errors.phone.message}
              </span>
            ) : null}
          </label>
          <label>
            Message *
            <textarea
              placeholder="What would you like to know?"
              rows="4"
              {...register("message")}
            />
            {errors.message ? (
              <span className="bl-connect-form__error">
                {errors.message.message}
              </span>
            ) : null}
          </label>

          {responseMessage ? (
            <div
              className={`bl-connect-form__message bl-connect-form__message--${responseType}`}
            >
              {responseMessage}
            </div>
          ) : null}

          <button
            className="bl-connect-form__button"
            type="submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              "Sending..."
            ) : (
              <>
                <span>Send message</span>
                <i className="fas fa-arrow-right" aria-hidden="true" />
              </>
            )}
          </button>
        </form>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} noValidate>
      <div className="form-grp">
        <input type="text" placeholder="Your Name" {...register("name")} />
        {errors.name ? (
          <p className="text-danger">{errors.name.message}</p>
        ) : null}
      </div>
      <div className="form-grp">
        <input type="email" placeholder="Your Email" {...register("email")} />
        {errors.email ? (
          <p className="text-danger">{errors.email.message}</p>
        ) : null}
      </div>
      <div className="form-grp">
        <input
          type="tel"
          placeholder="Phone (e.g. +380951664304)"
          className="no-arrows"
          {...register("phone")}
        />
        {errors.phone ? (
          <p className="text-danger">{errors.phone.message}</p>
        ) : null}
      </div>
      <div className="form-grp">
        <textarea
          placeholder="Please describe what you need"
          {...register("message")}
        />
        {errors.message ? (
          <p className="text-danger">{errors.message.message}</p>
        ) : null}
      </div>

      {responseMessage ? (
        <div
          className={`alert ${responseType === "success" ? "alert-success" : "alert-danger"}`}
        >
          {responseMessage}
          <button
            className="close-btn"
            type="button"
            onClick={() => setResponseMessage(null)}
          >
            x
          </button>
        </div>
      ) : null}

      <button className="btn" type="submit" disabled={isSubmitting}>
        {isSubmitting ? "Submitting..." : "Submit"}
      </button>
    </form>
  );
};

export default ContactForm;
